import { render, staticRenderFns } from "./Resultats.vue?vue&type=template&id=5647fab2&"
import script from "./Resultats.vue?vue&type=script&lang=js&"
export * from "./Resultats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports